// eslint-disable-next-line no-unused-vars
import fs from 'fs';
import * as API from '@/lib/API';
import store from '@/store';
import setupFormData from './setupFormData';
// import uploadFile from './uploadFile';

const sanitize = ( obj, options = {} ) => {
	const objKeys   = Object.keys( obj );
	const newObject = Array.isArray( obj ) ? [] : {};

	objKeys.forEach( ( key ) => {
		// check if there is a special
		// request for this key
		if ( options[key] ) {

			// if we're supposed to remove the
			// key, then just continue
			if ( options[key] === 'remove' ) {
				return;
			}
		}

		// if it's empty, we want to
		// strip it
		if ( obj[key] === null || obj[key] === '' ) {
			return;
		}

		// if the type is not an object, we
		// can simply copy over the value
		if ( typeof obj[key] !== 'object' ) {
			newObject[key] = obj[key];

			return;
		}

		const sanitizedChild = sanitize( obj[key] );
		const childHasValues = Object.keys( sanitizedChild ).length > 0;

		if ( childHasValues ) {
			// if it's an object that is not null,
			// we need to repeat this process on
			// the object
			newObject[key] = sanitize( obj[key] );
		}

	} );

	// return the copied object
	return newObject;
};

const user = $form => API.createUser( $form.value );

const editUser = ( $form, uid ) => {

	const displayState = store.dispatch( 'displayState', {
		message : 'Editing User...',
		state   : 'loading'
	} );

	const sanitizedUser = sanitize( $form, {
		uniqueKey          : 'remove',
		usersKey           : 'remove',
		notificationCount  : 'remove',
		notificationStatus : 'remove',
		uid                : 'remove'
	} );

	const profile = {
		type : 'user',
		data : sanitizedUser,
	};

	displayState
		.then( stateIndicator => API.editUser( profile, uid )
			.then( () => stateIndicator )
			.catch( () => stateIndicator.fail( { header : 'Didn\'t Edit User', message : '' } ) ) )
		.then( stateIndicator => stateIndicator.resolve( 'Edited Successfully' ) );

};

const job = ( $form ) => {
	const { value } = $form;
	const {	files : attachments, locationDescription, projectFee, fidCost	} = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;

	const addedOptions = ( () => {
		if ( value.type === 'Misc Job' ) {
			return {
				pipeType : 'remove',
				fund     : 'remove',
			};
		}

		return {};
	} )();

	const sanitizedJob = sanitize( value, {
		files : 'remove',
		...addedOptions,
	} );

	if ( projectFee ) {
		const i = projectFee.includes( ',' );
		if ( i ) {
			sanitizedJob.projectFee = parseInt( projectFee.split( ',' ).join( '' ), 10 );
		}
	}

	if ( fidCost ) {
		const i = fidCost.includes( ',' );
		if ( i ) {
			sanitizedJob.fidCost = parseInt( fidCost.split( ',' ).join( '' ), 10 );
		}
	}

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedJob.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'jobs', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedJob.folder = folderList;
		}
	}

	const data = setupFormData( 'job', sanitizedJob/* , attachments */ );

	if ( sanitizedJob.type === 'Misc Job' ) {
		return API.CreateMiscJob( data );
	}
	return API.CreateJob( data );
	// .then( results => uploadFile( results.job, attachments, store.state.postgresUser.driveLink ) );
};

const editJob = ( $form, type, jobsKey ) => {
	const { value } = $form;
	const { files : attachments, locationDescription, projectFee, fidCost } = value;

	console.log( 'value on update', value );

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;
	delete value.file;
	delete value.folder;

	const sanitizedJob = sanitize( value, {
		files : 'remove',
	} );

	if ( projectFee ) {
		const i = projectFee.includes( ',' );
		if ( i ) {
			sanitizedJob.projectFee = parseInt( projectFee.split( ',' ).join( '' ), 10 );
		}
	}

	if ( fidCost ) {
		const i = fidCost.includes( ',' );
		if ( i ) {
			sanitizedJob.fidCost = parseInt( fidCost.split( ',' ).join( '' ), 10 );
		}
	}

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedJob.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'jobs', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedJob.folder = folderList;
		}
	}

	sanitizedJob.type = type;

	const data = setupFormData( 'job', sanitizedJob/* , attachments */ );

	if ( sanitizedJob.type === 'Misc Job' ) {
		return API.EditMiscJob( data, jobsKey );
	}
	return API.EditJob( data, jobsKey );
	// .then( results => uploadFile( results.job, attachments, store.state.postgresUser.driveLink ) );
};

const agreement = ( $form ) => {
	const { value }               = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;

	const sanitizedAgreement = sanitize( $form.value, {
		files        : 'remove',
		gisReference : 'remove', // ! visual duplicate of mapReference
		driveLink    : 'remove',
	} );

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedAgreement.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'Agreement', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedAgreement.folder = folderList;
		}
	}

	const data = setupFormData( 'agreement', sanitizedAgreement/* , attachments */ );

	return API.CreateAgreement( data );
	// .then( results => uploadFile( results.agreement, attachments, store.state.postgresUser.driveLink ) );
};

const editAgreement = ( $form, agreementsKey ) => {
	const { value }               = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;
	delete value.file;
	delete value.folder;

	const sanitizedAgreement = sanitize( value, {
		files        : 'remove',
		gisReference : 'remove', // ! visual duplicate of mapReference
		driveLink    : 'remove',
	} );

	// console.log( attachments );

	if ( attachments ) {
		const fileList = [];

		attachments.forEach( attach => fileList.push( { name : attach.name } ) );

		if ( fileList[0] ) {
			sanitizedAgreement.file = fileList;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'Agreement', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedAgreement.folder = folderList;
		}
	}

	const data = setupFormData( 'agreement', sanitizedAgreement );

	return API.EditAgreement( data, agreementsKey );
	// .then( results => uploadFile( results.agreement, attachments, store.state.postgresUser.driveLink ) );
};

const review = ( $form ) => {
	const { value }               = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;

	const sanitizedReview = sanitize( value, {
		files     : 'remove',
		driveLink : 'remove',
	} );

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedReview.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'Review', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedReview.folder = folderList;
		}
	}

	sanitizedReview.reviewsTypes = sanitizedReview.reviewsTypes.map( ( { reviewsTypesKey, text } ) => ( {
		reviewsTypesKey,
		description : text,
	} ) );

	const data = setupFormData( 'review', sanitizedReview/* , attachments */ );

	return API.CreateReview( data );
	// .then( results => uploadFile( results.review, attachments, store.state.postgresUser.driveLink ) );
};

const editReview = ( $form, id ) => {
	const { value }               = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;
	delete value.file;
	delete value.folder;

	const sanitizedReview = sanitize( value, {
		files     : 'remove',
		driveLink : 'remove',
	} );

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedReview.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'Review', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedReview.folder = folderList;
		}
	}

	sanitizedReview.reviewsTypes = sanitizedReview.reviewsTypes.map( ( { reviewsTypesKey, text } ) => ( {
		reviewsTypesKey,
		description : text,
	} ) );

	const data = setupFormData( 'review', sanitizedReview/* , attachments */ );

	return API.EditReview( data, id );
	// .then( results => uploadFile( results.review, attachments, store.state.postgresUser.driveLink ) );

};

const request = ( $form ) => {
	const { value }               = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;

	const sanitizedRequest = sanitize( $form.value, {
		files     : 'remove',
		driveLink : 'remove',
	} );

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedRequest.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'action-requests', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedRequest.folder = folderList;
		}
	}

	const data = setupFormData( 'actionRequest', sanitizedRequest/* , attachments */ );

	return API.CreateRequest( data );
	// .then( results => uploadFile( results.actionRequest, attachments, store.state.postgresUser.driveLink ) );
};

const editRequest = ( $form, actionRequestsKey ) => {
	const { value }               = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;
	delete value.file;
	delete value.folder;

	const sanitizedRequest = sanitize( $form.value, {
		files     : 'remove',
		driveLink : 'remove',
	} );

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedRequest.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'action-requests', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedRequest.folder = folderList;
		}
	}

	const data = setupFormData( 'actionRequest', sanitizedRequest/* , attachments */ );

	return API.EditRequest( data, actionRequestsKey );
	// .then( results => uploadFile( results.actionRequest, attachments, store.state.postgresUser.driveLink ) );
};

const facility = ( $form ) => {

	const { value } = $form;
	const sanitized = sanitize( value );

	return API.CreateFacility( setupFormData( 'facility', sanitized ) );
};

const editFacility = ( $form, facilitiesKey ) => {
	const sanitized = sanitize( $form.value );
	const value     = setupFormData( 'facility', sanitized );

	return API.EditFacility( value, facilitiesKey );
};

const permit = ( $form ) => {
	const { value }               = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;

	const sanitizedPermit = sanitize( value, {
		files     : 'remove',
		number    : 'remove',
		driveLink : 'remove',
	} );

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedPermit.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'Permit', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedPermit.folder = folderList;
		}
	}

	const data = setupFormData( 'permit', sanitizedPermit/* , attachments */ );

	return API.CreatePermit( data );
	// .then( results => uploadFile( results.permit, attachments, store.state.postgresUser.driveLink ) );
};

const editPermit = ( $form, id ) => {
	const { value }                       = $form;
	const { files : attachments, locationDescription } = value;

	value.location.description = locationDescription || ' ';

	delete value.locationDescription;
	delete value.file;
	delete value.folder;

	const sanitizedPermit = sanitize( value, {
		files     : 'remove',
		number    : 'remove',
		driveLink : 'remove',
	} );

	if ( attachments ) {
		const list = [];

		attachments.forEach( attach => list.push( { name : attach.name } ) );

		if ( list[0] ) {
			sanitizedPermit.file = list;
		}

		const folderList = [];

		attachments.forEach( a => folderList.push( { relatesTo : 'Permit', folderUri : a.path.split( '\\' ).slice( 1, -1 ).join( '\\' ), } ) );

		// console.log( folderList );

		if ( folderList[0] ) {
			sanitizedPermit.folder = folderList;
		}
	}

	const data = setupFormData( 'permit', sanitizedPermit/* , attachments */ );

	return API.EditPermit( data, id );
	// .then( results => uploadFile( results.permit, attachments, store.state.postgresUser.driveLink ) );
};

export default {
	user,
	editUser,
	job,
	editJob,
	agreement,
	editAgreement,
	review,
	editReview,
	request,
	editRequest,
	facility,
	editFacility,
	permit,
	editPermit,
};
